import { useConfigStore } from '../feature-flags/useConfigStore'
import { siteSettingsSchema } from '../../composables/feature-flags/index.types'

export const useSiteSettingsStore = useConfigStore({
  defaults: siteSettingsSchema.parse({
    userSettings: {
      position: 'off',
      defaultSettings: {
        theme: 'light',
        articleSummary: true,
      },
      enabledSettings: {
        articleSummary: false,
      },
    },
    enableLocalNewsSearch: true,
    sortNewsBy: 'clusterSize',
    enableArticleReordering: false,
    videoEnabled: false,
  }),
  configStoreKey: 'siteSettings',
  schema: (data) => siteSettingsSchema.parse(data),
})
